module.exports = __webpack_public_path__ + "../assets/mobile-5.jpg";